var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/upload"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16 14-4-4m0 0-4 4m4-4v11m-4.5-4H4.667C2.642 17 1 15.329 1 13.267c0-2.062 1.642-3.734 3.667-3.734h.015C4.918 5.885 7.899 3 11.542 3c3 0 5.55 1.956 6.49 4.683.126-.01.255-.016.385-.016 2.531 0 4.583 2.089 4.583 4.666C23 14.911 20.948 17 18.417 17H16",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b8578da50d3e68183a8a299af061c9a2.svg";
export { ForwardRef as ReactComponent };